const PAYMENT_METHODS = [
  { value: "ACH", label: "ACH" },
  { value: "Credit Card", label: "Credit Card" },
  { value: "Debit Card", label: "Debit Card" },
  { value: "PayPal", label: "PayPal" },
  { value: "Terms", label: "Terms" },
];

export default PAYMENT_METHODS;
